module.exports = __webpack_public_path__ + "static/media/landing.9c792f67.jpg";